import { render, staticRenderFns } from "./PayoffList.vue?vue&type=template&id=61d51cc0&scoped=true"
import script from "./PayoffList.vue?vue&type=script&lang=js"
export * from "./PayoffList.vue?vue&type=script&lang=js"
import style0 from "./PayoffList.vue?vue&type=style&index=0&id=61d51cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d51cc0",
  null
  
)

export default component.exports